import { CSSObject, DefaultTheme, useTheme } from "styled-components";

interface DialogStyles {
    confirmationContainer: CSSObject;
    btnClose: CSSObject;
    contentBox: CSSObject;
    flex: CSSObject;
    text: CSSObject;
    title: CSSObject;
}
export const UseDialogStyles = (): DialogStyles => {
    const theme: DefaultTheme = useTheme();
    return {
        confirmationContainer: {
            margin: theme.spacePx.sp03,
            minWidth: "428px",
        },
        btnClose: {
            position: "absolute",
            right: theme.spacePx.sp05,
            top: theme.spacePx.sp06,
            cursor: "pointer",
        },
        contentBox: {
            marginBottom: theme.spacePx.sp04,
            marginTop: theme.spacePx.sp02,
        },
        flex: {
            display: "block",
            justifyContent: "space-between",
        },
        text: {
            color: theme.palette.black,
            fontSize: theme.font.sizes.md,
        },
        title: {
            alignSelf: "center",
            color: theme.palette.text.main,
            fontFamily: theme.font.family,
            fontWeight: theme.font.weights.semiBold,
            fontSize: theme.font.sizes.md,
            lineHeight: theme.font.sizes.md,
        },
    };
};
